import * as React from 'react';

import { auth } from '../../firebase';
import { loadDispensaryProducts } from '../products/product-utils';
import { groupByStandardCategories } from '../products/product-utils';
import BodyWrapper from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import DisplayModal  from '../common/DisplayModal';
import Spinner from '../common/Spinner';
import ProductDetail from './ProductDetail';
import ProductTypes from '../home/ProductTypes';
import UpdateProductInfo from './UpdateProductInfo';
import Helmet from 'react-helmet';

import styles from './AllProducts.module.css';

class AllProducts extends React.Component {

  constructor(props) {
    super();
    this.state = {
      products: [],
      filteredProducts: [],
      productsById: {},
      productsByType: {},
      modalProductId: 0,
      modalProductName: '',
      productType: ''
    };
  }

  // To cancel XHR requests on unmount
  abortController = new AbortController();  

  dispensaryCallback = (products) => {
    const productsById = products.data.reduce((map, product) => map.set(product.id, product.metrc_product), new Map());
    const productsByType = groupByStandardCategories(products);
    
    console.log(productsByType);
  
    this.setState({ 
      products: products.data,
      productsById,
      productsByType,
    }, () => this.switchType(this.state.productType));
  } 

  requestProducts() {
    const { dispensaryId } = this.props; 
    try {
      loadDispensaryProducts(dispensaryId, this.dispensaryCallback, this.abortController);
    } catch(error) {
      // trackEvent('error_fetch_dispensary',`${this.props.dispensaryId}: error`);
    }
  }

  componentDidMount(){
    const { dispensaryId } = this.props; 
    if (dispensaryId && !this.state.products.length) {
      this.requestProducts();
    }
  }  

  componentDidUpdate(){
    const { dispensaryId } = this.props; 
    if (dispensaryId && !this.state.products.length) {
      this.requestProducts();
    }
  }  
  
  componentWillUnmount(){
    this.abortController.abort();
  }
  
  switchType = (type) => {
    const products = this.state.productsByType[type] || [];
    this.setState({
      productType: type,
      filteredProducts: products  
    });
  }

  // enable product config
  adminEmails = ['doug@ziprun.com', 'mike@ziprun.com'];

  render() {
    const filteredProducts = this.state.filteredProducts.length 
      ? this.state.filteredProducts
      : this.state.products;

    return (
      <BodyWrapper>
      <Helmet>
        <title>Zip Run - All Metrc Products</title>
      </Helmet>  
      { filteredProducts.length 
        ? <>
            <div style={{paddingTop:'2rem'}}></div>
            <PrimaryHeader isCentered text={`Product Category: ${this.state.productType || 'All'} (${filteredProducts.length})`} />
            <ProductTypes isCondensed handleFilterClick={this.switchType} />
            
            { this.adminEmails.indexOf(auth.currentUser.email) > -1 && 
              <UpdateProductInfo dispensaryId={this.props.dispensaryId} onUpdate={() => {
                this.setState({ filteredProducts:[] });
                this.requestProducts();
              }} />
            }
        
            <table className={styles.prodTable}>
              <tbody>
                <tr className={styles.tableRow}>
                  <th align="left">Id</th>
                  <th align="left">Name</th>
                  <th align="left">Metrc&nbsp;Category</th>
                  <th align="left">DISPLAY:&nbsp;Name</th>
                  <th align="left">Description</th>
                  <th align="left">Category</th>
                  <th align="left">Price</th>
                </tr>  
                { filteredProducts.map(product => {
                  return (
                    <tr className={styles.tableRow} key={product.id}> 
                      <td>{ product.id }</td>
                      <td className={styles.prodName} 
                         onClick={() => this.setState({ 'modalProductId':product.id, 'modalProductName': product.metrc_product.Name })}>
                        { product.metrc_product.Name }  
                      </td>
                      <td>{ product.metrc_product.ProductCategoryName }</td>

                      { product.display_info.name && product.display_info.name !== product.metrc_product.Name 
                        ? <td className={styles.displayData}>{product.display_info.name}</td>
                        : <td className={styles.displayData}></td>
                      }
                      
                      { product.display_info.description
                        ? <td className={styles.displayData}>
                            <button onClick={() => {
                              alert(product.display_info.description);
                              return false;
                            }}>Desc</button>
                          </td>
                        : <td className={styles.displayData}></td>
                      }
              
                      { product.display_info.category && product.display_info.category.display_name
                        ? <td className={styles.displayData}>{product.display_info.category.display_name}</td>
                        : <td className={styles.displayData}></td>
                      }

                      { product.display_info.cost_usa_cents
                        ? <td className={styles.displayData}>${parseFloat(product.display_info.cost_usa_cents/100).toFixed(2)}</td>
                        : <td className={styles.displayData}></td>
                      } 

                    </tr>
                  )
                })}
              </tbody>
            </table>
            
            { this.state.modalProductId > 0 && 
              <DisplayModal title={this.state.modalProductName} closeFn={() => this.setState({ 'modalProductId':0, 'modalProductName': '' })}>
                <ProductDetail product={this.state.productsById.get(this.state.modalProductId)} />
              </DisplayModal>
            } 
        </>  
        : <div>
            <Spinner inSmallLayout />
          </div>
      }
      </BodyWrapper>
    )
  }
}

export default  AllProducts;